import React from 'react';
import { createPortal } from 'react-dom';
import OverlayVideo, { OverlayVideoProps } from './overlay.video';

const OverlayVideoPortal = (props: OverlayVideoProps): JSX.Element => {
  const overlayRenderTarget = typeof document !== 'undefined' && document.getElementsByTagName('main')[0];

  if (!overlayRenderTarget) return;

  return createPortal(<OverlayVideo {...props} />, overlayRenderTarget);
};

export default OverlayVideoPortal;
